import { ReactNode } from 'react';
import { addDays, format, isSameDay, startOfDay } from 'date-fns';

export default function getClickCollectFormattedTime({
  bold = true,
  time,
  timeOnly = false,
}: { bold?: boolean; time?: Date | string | number; timeOnly?: boolean }): string | ReactNode {
  if (!time) return '';

  const collectDay = startOfDay(time);
  const formatToHour = format(time, 'h:mma');
  const formatted24HourTime = format(time, 'HH:mm');
  const timeNowTomorrow = addDays(startOfDay(new Date()), 1);

  const day = isSameDay(collectDay, timeNowTomorrow) ? 'tomorrow' : format(time, 'dddd Do MMMM YYYY');

  if (timeOnly) {
    return formatToHour;
  }

  if (formatted24HourTime === '00:00') {
    return bold ? <>from <strong>{day}</strong></> : `from ${day}`;
  }

  return bold ? <>from <strong>{formatToHour} {day}</strong></> : `from ${formatToHour} ${day}`;
}
